import _ from "lodash";

const state = () => ({
    pagination: {
        size: 10,
        page: 0
    },
    searchForm: {
        orgId: "",
        classificationId: "",
        occupationId: "",
        occupationLevel: "",
        certificateType: "",
        registrationStatus: "",
        keyword: "",
        sortKey: "new"
    }
});

const getters = {
    pagination: state => {
        return state.pagination;
    },
    searchForm: state => {
        return state.searchForm;
    },
    isEmptySearch: state => {
        return (
            !state.searchForm.orgId &&
            !state.searchForm.classificationId &&
            !state.searchForm.occupationId &&
            _.isEmpty(state.searchForm.occupationLevel) &&
            _.isEmpty(state.searchForm.certificateType) &&
            _.isEmpty(state.searchForm.registrationStatus)
        );
    }
};

const actions = {
    nextPage: ({ commit }) => {
        commit("nextPage");
    },
    resetPage: ({ commit }) => {
        commit("resetPage");
    },
    orgId: ({ commit }, { filterValue }) => {
        commit("orgId", filterValue);
    },
    keyword: ({ commit }, { filterValue }) => {
        commit("keyword", filterValue);
    },
    classificationId: ({ commit }, { filterValue }) => {
        commit("classificationId", filterValue);
    },
    occupationId: ({ commit }, { filterValue }) => {
        commit("occupationId", filterValue);
    },
    occupationLevel: ({ commit }, { filterValue }) => {
        commit("occupationLevel", filterValue);
    },
    certificateType: ({ commit }, { filterValue }) => {
        commit("certificateType", filterValue);
    },
    registrationStatus: ({ commit }, { filterValue }) => {
        commit("registrationStatus", filterValue);
    },
    sortKey: ({ commit }, { filterValue }) => {
        commit("sortKey", filterValue);
    },
    resetFilter: ({ commit }) => {
        commit("resetFilter");
    }
};

const mutations = {
    nextPage: state => {
        state.pagination.page++;
    },
    resetPage: state => {
        state.pagination.page = 0;
        state.pagination.size = 10;
    },
    resetFilter: state => {
        state.searchForm.orgId = "";
        state.searchForm.classificationId = "";
        state.searchForm.occupationId = "";
        state.searchForm.occupationLevel = "";
        state.searchForm.certificateType = "";
        state.searchForm.registrationStatus = "";
        state.searchForm.sortKey = "new";
    },
    orgId: (state, orgId) => {
        state.searchForm.orgId = orgId;
    },
    keyword: (state, keyword) => {
        state.searchForm.keyword = keyword;
    },
    classificationId: (state, classificationId) => {
        state.searchForm.classificationId = classificationId;
    },
    occupationId: (state, occupationId) => {
        state.searchForm.occupationId = occupationId;
    },
    occupationLevel: (state, occupationLevel) => {
        state.searchForm.occupationLevel = occupationLevel;
    },
    certificateType: (state, certificateType) => {
        state.searchForm.certificateType = certificateType;
    },
    registrationStatus: (state, registrationStatus) => {
        state.searchForm.registrationStatus = registrationStatus;
    },
    sortKey: (state, sortKey) => {
        state.searchForm.sortKey = sortKey;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
